"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Settings = void 0;
exports.Settings = {
    debug: {
        fpsMeter: {
            theme: "transparent",
            heat: 20,
            graph: 1,
            history: 20,
            zIndex: 10000,
            top: "80%"
        }
    }
};
//# sourceMappingURL=settings.js.map